import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './contexts/AuthContext';
import { CartProvider } from './contexts/CartContext';
import PrivateRoute from './components/auth/PrivateRoute';
import Layout from './components/layout/Layout';

// Pages
import Home from './pages/Home';
import Login from './pages/auth/Login';
import Register from './pages/auth/Register';
import Dashboard from './pages/Dashboard';
import StudentDashboard from './pages/StudentDashboard';
import AdminDashboard from './pages/AdminDashboard';
import AdminCourses from './pages/admin/AdminCourses';
import AdminCreateCourse from './pages/admin/AdminCreateCourse';
import AdminEditCourse from './pages/admin/AdminEditCourse';
import AdminUsers from './pages/admin/AdminUsers';
import AdminPosts from './pages/admin/AdminPosts';
import Courses from './pages/Courses';
import CourseDetail from './pages/CourseDetail';
import CourseLearning from './pages/CourseLearning';
import Profile from './pages/Profile';
import StudentMyCourses from './pages/StudentMyCourses';
import LearningStats from './pages/LearningStats';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import NotFound from './pages/NotFound';
import About from './pages/About';
import Contact from './pages/Contact';
import ContactManagement from './pages/ContactManagement';
import Notifications from './pages/Notifications';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentFail from './pages/PaymentFail';
import LogoTest from './components/ui/LogoTest';
import SpeakingPT from './pages/SpeakingPT';
import WritingPT from './pages/WritingPT';
import TermsOfService from './pages/TermsOfService';
import PrivacyPolicy from './pages/PrivacyPolicy';

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <div className="App">
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/courses" element={<Courses />} />
              <Route path="/courses/:id" element={<CourseDetail />} />
              <Route path="/courses/:courseId/learn" element={<PrivateRoute><CourseLearning /></PrivateRoute>} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
              <Route path="/student-dashboard" element={<PrivateRoute><StudentDashboard /></PrivateRoute>} />
              <Route path="/admin-dashboard" element={<PrivateRoute adminOnly><AdminDashboard /></PrivateRoute>} />
              <Route path="/admin/courses" element={<PrivateRoute adminOnly><AdminCourses /></PrivateRoute>} />
              <Route path="/admin/courses/create" element={<PrivateRoute adminOnly><AdminCreateCourse /></PrivateRoute>} />
              <Route path="/admin/courses/:courseId/edit" element={<PrivateRoute adminOnly><AdminEditCourse /></PrivateRoute>} />
              <Route path="/admin/users" element={<PrivateRoute adminOnly><AdminUsers /></PrivateRoute>} />
              <Route path="/admin/posts" element={<PrivateRoute adminOnly><AdminPosts /></PrivateRoute>} />
              <Route path="/profile" element={<PrivateRoute><Profile /></PrivateRoute>} />
              <Route path="/my-courses" element={<PrivateRoute><StudentMyCourses /></PrivateRoute>} />
              <Route path="/learning-stats" element={<PrivateRoute><LearningStats /></PrivateRoute>} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/checkout" element={<PrivateRoute><Checkout /></PrivateRoute>} />
              <Route path="/contact-management" element={<PrivateRoute><ContactManagement /></PrivateRoute>} />
              <Route path="/notifications" element={<PrivateRoute><Notifications /></PrivateRoute>} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/fail" element={<PaymentFail />} />
              <Route path="/speaking-pt" element={<SpeakingPT />} />
              <Route path="/writing-pt" element={<WritingPT />} />
              <Route path="/terms" element={<TermsOfService />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/logo-test" element={<LogoTest />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Layout>
          <Toaster position="top-right" />
        </div>
      </CartProvider>
    </AuthProvider>
  );
}

export default App; 